var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled, { css } from "../themes/styled";
import * as SS from "styled-system";
import { ifProp, prop } from "styled-tools";
import { textVariants } from "./textVariants";
var Base = styled.span.attrs(function (p) { return ({
    textDecoration: p.href && !p.textDecoration ? "underline" : p.textDecoration,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    /* normalize browser styles */\n    font-style: ", ";\n    text-decoration: ", ";\n    text-transform: ", ";\n    -webkit-font-smoothing: ", ";\n    margin: 0;\n    padding: 0;\n    /* Set defaults here so they can be overriden by either typeStyles or props*/\n    font-family: ", ";\n\n    ", ";\n\n    /* These appear after typesStyles so we can override any aspect of a typeStyle */\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    ", ";\n    a {\n        ", ";\n    }\n"], ["\n    /* normalize browser styles */\n    font-style: ", ";\n    text-decoration: ", ";\n    text-transform: ", ";\n    -webkit-font-smoothing: ", ";\n    margin: 0;\n    padding: 0;\n    /* Set defaults here so they can be overriden by either typeStyles or props*/\n    font-family: ",
    ";\n\n    ",
    ";\n\n    /* These appear after typesStyles so we can override any aspect of a typeStyle */\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    ",
    ";\n    a {\n        ", ";\n    }\n"])), prop("fontStyle", "initial"), prop("textDecoration", "initial"), prop("textTransform", "none"), function (p) { return (p.fontWeight === "light" ? "subpixel-antialiased" : "antialiased"); }, function (p) {
    if (p.fontFamily) {
        return p.theme.fonts[p.fontFamily];
    }
    return p.theme.fonts["primary"];
}, SS.variant({
    scale: "typeStyles",
    prop: "typeStyle",
    variants: textVariants,
}), SS.border, SS.color, SS.flexbox, SS.grid, SS.layout, SS.position, SS.space, SS.typography, ifProp("onClick", css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            text-decoration: underline;\n            cursor: pointer;\n        "], ["\n            text-decoration: underline;\n            cursor: pointer;\n        "])))), SS.color);
export var Text = function (props) {
    return React.createElement(Base, __assign({}, props));
};
Text.defaultProps = {
    display: "block",
    color: "text",
    bg: "transparent",
    border: "none",
};
Text.displayName = "Text";
export default Text;
export var H1 = function (props) {
    return React.createElement(Text, __assign({ as: "h1", fontSize: [10, 10, 12, 14], fontWeight: "bold", lineHeight: 2, mb: 6 }, props));
};
export var H2 = function (props) {
    return React.createElement(Text, __assign({ as: "h2", fontSize: [8, 8, 8, 10, 12], fontWeight: "bold", lineHeight: 2, mb: 5 }, props));
};
export var H3 = function (props) {
    return React.createElement(Text, __assign({ as: "h3", fontSize: [6, 6, 7, 8, 9], fontWeight: "bold", lineHeight: 3, mb: 4 }, props));
};
export var H4 = function (props) {
    return (React.createElement(Text, __assign({ as: "h4", fontSize: [4, 4, 4, 4, 5], fontWeight: "heavy", textTransform: "uppercase", lineHeight: 3, mb: 2 }, props)));
};
export var H5 = function (props) {
    return (React.createElement(Text, __assign({ as: "h5", fontSize: 2, fontWeight: "heavy", textTransform: "uppercase", lineHeight: 2, mb: 2 }, props)));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Text.js.map